import {useStepCheck} from "../hooks/stepcheck/useStepCheck";
import {useParams, useSearchParams} from "react-router-dom";
import {RouteParam} from "../types/types";
import React, {useEffect} from "react";
import {useThemeSelector} from "../hooks/theme/useThemeSelector";
import {LoadingComponent} from "../components/common/loading/LoadingComponent";

export const ThemeSetterPage: React.FC = () => {

    const [searchParams] = useSearchParams();
    const { verificationId } = useParams<RouteParam>();
    const { evaluateUrl } = useStepCheck(verificationId)
    const { themeSet } = useThemeSelector(true)

    useEffect(() => {
        if (themeSet) {
            if (searchParams.get("app")) {
                evaluateUrl(true)
            } else {
                evaluateUrl()
            }
        }
    }, [evaluateUrl, themeSet, searchParams])

    return (
        <LoadingComponent/>
    )

}